import React from 'react'
import { useParams } from 'react-router-dom'
import ComplianceShell from 'features/compliance/ComplianceShell'
import ByLegislation from 'features/compliance/legislation/ByLegislation'

const LegislationPage = ({ bpId: bpIdProp, embedded = false, onTabChange, chromeless = false } = {}) => {
  const routeParams = useParams()
  const bpId = bpIdProp ?? routeParams.bpId
  return (
    <ComplianceShell activeTab='legislation' bpId={bpId} embedded={embedded} onTabChange={onTabChange} chromeless={chromeless}>
      <ByLegislation bpId={bpId} />
    </ComplianceShell>
  )
}

export default LegislationPage
